import React, { useState, useRef, useEffect } from "react";

const DropdownMenu = ({ button, items = [], fullWidth = false }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={menuRef}>
      {/* Trigger Button */}
      <div onClick={() => setOpen(!open)}>{button}</div>

      {/* Dropdown */}
      {open && (
        <div className={`absolute right-0 mt-2 ${fullWidth ? 'w-full' : 'w-56'} bg-theme_clr1 text-white rounded-lg shadow-lg border border-white overflow-hidden z-50`}>
          {items.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                item.onClick?.();
                setOpen(false);
              }}
              className={`flex items-center justify-between w-full px-4 py-2 text-left hover:bg-[#11175c] ${
                item.danger ? "text-red-400 hover:bg-red-900/40" : ""
              }`}
            >
              <div className="flex items-center gap-2">
                {item.icon && <span>{item.icon}</span>}
                <span>{item.label}</span>
              </div>
              {item.badge && (
                <span className="ml-2 text-xs bg-blue-600 text-white px-2 py-0.5 rounded-full">
                  {item.badge}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
